// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App'
import addinConfig from './helpers/addin-config.js'

Vue.use(VueI18n)
Vue.config.productionTip = false

const Office = window.Office

import messages from './i18n/messages.js'

Office.initialize = () => {
  new Vue({
    el: '#app',
    i18n: new VueI18n({
      locale: addinConfig.getLocale(),
      fallbackLocale: 'en',
      messages
    }),
    components: {App},
    template: '<App/>'
  })
}

window.run = function() {
  new Vue({
    el: '#app',
    i18n: new VueI18n({
      locale: addinConfig.getLocale(),
      fallbackLocale: 'en',
      messages
    }),
    components: {App},
    template: '<App/>'
  })
}



// WEBPACK FOOTER //
// ./src/main.js